const FIRST_PAGE = 0;
const DEFAULT_ROWS_PER_PAGE = 25;
const MAX_ROWS = 100;
const PAGINATION_INITIAL_STATE = { page: FIRST_PAGE, pageSize: DEFAULT_ROWS_PER_PAGE };
const DEFAULT_ESTIMATED_ROW_HEIGHT = 57;
const ACTION_COLUMN_WIDTH = 56;
const COLUMN_WIDTH_SAMPLE_SIZE = 20;
const BULK_ACTION_FIELD = "__check__";
const DEFAULT_EMPTY_TEXT = "Nothing here yet";
const DEFAULT_EMPTY_SEARCH_TEXT = "No results found";
const DEFAULT_EMPTY_SEARCH_DESCRIPTION = "Check your search term and try again";
const WIDTHS = {
  ARRAY_EXTRA_WIDTH: 100,
  COLUMN_MAX_WIDTH: 400,
  EXTRA_PADDING: 60,
  EXTRA_PADDING_FIRST_COLUMN: 72
};
const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc"
};
const PAGINATION_MODES = {
  CLIENT: "client",
  SERVER: "server"
};

export {
  FIRST_PAGE,
  DEFAULT_ROWS_PER_PAGE,
  MAX_ROWS,
  PAGINATION_INITIAL_STATE,
  DEFAULT_ESTIMATED_ROW_HEIGHT,
  BULK_ACTION_FIELD,
  DEFAULT_EMPTY_TEXT,
  DEFAULT_EMPTY_SEARCH_TEXT,
  DEFAULT_EMPTY_SEARCH_DESCRIPTION,
  WIDTHS,
  SORT_DIRECTIONS,
  ACTION_COLUMN_WIDTH,
  COLUMN_WIDTH_SAMPLE_SIZE,
  PAGINATION_MODES
};
